// ------------------ AWS S3 Configurations --------------------
import AWS from "aws-sdk";
console.log("-----------env: ", process.env.REACT_APP_S3_BUCKET);
export const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;
const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const SECRET_ACCESS_KEY = process.env.REACT_APP_SECRET_ACCESS_KEY;
// const S3_BUCKET = "whatsappbotmedia";
// const REGION = "us-east-2";
// const ACCESS_KEY = "AKIAS3IZSISFEAEHHH64";
// const SECRET_ACCESS_KEY = "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";

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
export const S3 = new AWS.S3({
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
// -------------------------------------------------------------

// ---------------------- Editor Options -----------------------
export const EditorOptions = {
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["bold", "italic", "underline"],
    //["strike"],
    //["subscript", "superscript"],
    ["fontColor", "hiliteColor"],
    //["textStyle"],
    ["outdent", "indent"],
    ["align", "list", "lineHeight", "horizontalRule"],
    ["removeFormat"],
    "/",
    //["table", "link", "image", "video", "audio"],
    //["fullScreen", "showBlocks", "codeView"],
    //["preview", "print"]
  ],
  callBackSave: (contents) => {
    console.log("Save:", contents);
  },
};
// -------------------------------------------------------------
